import { useGet } from '../../../sharedModules/hooks/useQuery';
import { BackflowJobItem } from '../../model';

const FLAGGED_DEVICES_URL = '/backflows/backflow_job_items';

const FLAGGED_DEVICES_PARAMS = {
  'ransack[processed_eq]': 'false',
  'ransack[backflow_job_group_status_in]': ['approved', 'complete'],
};

export function useFlaggedDevices(options?: { enabled?: boolean }) {
  return useGet<{ result: BackflowJobItem[] }>({
    url: FLAGGED_DEVICES_URL,
    params: FLAGGED_DEVICES_PARAMS,
    enabled: options?.enabled,
  });
}
